import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Station {
  id: number;
  name: string;
  table_name: string;
  image_url?: string;
  parameters_list?: any[];
}

@Injectable({
  providedIn: 'root',
})
export class Homeservice {
  private selectedStationSource = new BehaviorSubject<Station | null>(null);

  // Observable (READ-ONLY)
  selectedStation$ = this.selectedStationSource.asObservable();

  // Setter (WRITE)
  setSelectedStation(station: Station | null) {
    this.selectedStationSource.next(station);
    if (station) {
      localStorage.setItem('selected_station_id', station.id.toString());
    }
  }
}
